import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, batch } from 'react-redux';
import { navigatingFolders } from '../../actions/folders';
import { isChangingEmailSaveLocation } from '../../actions/mail';
import Svg from '../shared/Svg';
import colors from '../../utils/colors';
import { setCurrentFileId } from '../../actions/files';
import './OpenFolder.scss';

export const OpenFolder = ({ itemId, disabled, clickAction }) => {
  const dispatch = useDispatch();

  const onClickAction = () => {
    if (disabled) {
      return;
    }
    if (clickAction) {
      clickAction(true);
    }
    batch(() => {
      dispatch(isChangingEmailSaveLocation(true));
      dispatch(navigatingFolders(true));
      dispatch(setCurrentFileId(itemId));
    });
  };

  return (
    <div className='openFolder-component'>
      <Svg
        onClickAction={onClickAction}
        className={`openFolder-icon ${disabled ? 'openFolder-disabled' : ''}`}
        data='/assets/open_folder.svg'
        fill={disabled ? colors.lightGrey : colors.searchGrey}
        tooltipContent={disabled ? '' : <span>Change folder</span>}
        hoverable={disabled ? false : true}
        hoverFill={colors.iconHover}
      />
    </div>
  );
};
OpenFolder.propTypes = {
  itemId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  clickAction: PropTypes.func,
};
